import 'core-js/stable'
import 'regenerator-runtime/runtime'
import './polyfill/ImageData'
import React, { Suspense } from 'react'
import ReactDOM from 'react-dom'
import { PersistGate } from 'redux-persist/integration/react'
import { BrowserRouter } from 'react-router-dom'
import { Provider } from 'react-redux'

import createStore from './config/StoreConfig'
import * as serviceWorker from './serviceWorker'

import App from './containers/App'
import Loader from './components/Common/Loader/Loader'
import ErrorBoundary from './components/ErrorBoundary/ErrorBoundary'

import './config/i18n'
import './config/sentry'
import './index.scss'

const {
  store,
  persistor
} = createStore()

const Root = () => {
  const loader = <Loader isLoading={true} />

  return (
    <Provider store={store}>
      <PersistGate
        loading={loader}
        persistor={persistor}
      >
        <BrowserRouter basename={process.env.PUBLIC_URL}>
          <Suspense fallback={loader}>
            <ErrorBoundary>
              <App />
            </ErrorBoundary>
          </Suspense>
        </BrowserRouter>
      </PersistGate>
    </Provider>
  )
}

ReactDOM.render(<Root />, document.getElementById('root'))

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
